export default "__VITE_ASSET__SMAmFdUC__"